import React, { useState } from "react";
import "./DownloadAppCard.css";

/**
 * "Get the desktop app" card for the studio dashboard. Detects the visitor's
 * OS and leads with the right installer; the other platform stays one click
 * away underneath. Hidden inside the desktop app itself (pointless there) and
 * remembers dismissal so it doesn't nag.
 *
 * Links are the stable names served by the API's /downloads route — new
 * releases overwrite the same filenames, so these URLs never rot.
 */
const DOWNLOADS = {
	windows: {
		label: "Download for Windows",
		href: "/downloads/Photentra-Setup-Windows.exe",
		note: "Windows 10/11 · 64-bit",
	},
	mac: {
		label: "Download for Mac",
		href: "/downloads/Photentra-macOS.dmg",
		note: "macOS · Apple Silicon",
	},
};

const DISMISS_KEY = "photentra_desktop_card_dismissed";

export function detectPlatform(ua, platform) {
	const hay = `${ua || ""} ${platform || ""}`;
	if (/Mac|iPhone|iPad/i.test(hay)) return "mac";
	if (/Win/i.test(hay)) return "windows";
	return null;
}

function DownloadAppCard() {
	const [dismissed, setDismissed] = useState(
		() => localStorage.getItem(DISMISS_KEY) === "1",
	);

	// Inside the desktop app there is nothing to download; mobile browsers can't
	// run the installer; unknown platforms (Linux) have no build yet.
	const platform = detectPlatform(navigator.userAgent, navigator.platform);
	if (window.photentra?.isDesktop || dismissed || !platform) return null;

	const primary = DOWNLOADS[platform];
	const other = DOWNLOADS[platform === "mac" ? "windows" : "mac"];

	const dismiss = () => {
		localStorage.setItem(DISMISS_KEY, "1");
		setDismissed(true);
	};

	return (
		<div className="dl-app-card">
			<div className="dl-app-icon">🖥️</div>
			<div className="dl-app-body">
				<h3>Photentra for desktop</h3>
				<p>
					Live Folder Sync: point it at the folder your camera or card reader
					writes into, and photos land in your event as they're shot — even with
					the window closed.
				</p>
				<div className="dl-app-actions">
					<a className="dl-app-btn" href={primary.href} download>
						{primary.label}
					</a>
					<span className="dl-app-note">{primary.note}</span>
				</div>
				<a className="dl-app-other" href={other.href} download>
					{other.label.replace("Download for", "Also available for")}
				</a>
			</div>
			<button className="dl-app-close" onClick={dismiss} aria-label="Dismiss">
				×
			</button>
		</div>
	);
}

export default DownloadAppCard;
